import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from 'baby-design'
import NiceModal from '@ebay/nice-modal-react'
import { Reservation } from 'src/types/reservation'
import useUnmarkAsPurchased from 'src/routes/(registry)/registry/(gift-tracker-revamp)/hooks/useUnmarkAsPurchased/useUnmarkAsPurchased'
import { showUnmarkedAsPurchasedToast } from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/GiftDetailsDrawer/UnmarkedAsPurchasedToast'
import useGetRegistry from 'src/routes/(subdomains)/(my)/[slug]/hooks/useGetRegistry'
import useTrackedUnmarkModal from 'src/routes/(registry)/registry/(gift-tracker-revamp)/hooks/useTrackedUnmarkModal/useTrackedUnmarkModal'
import { GiftActionsProps } from './GiftActions.types'

const GiftActions: React.FC<GiftActionsProps> = ({
  onUnmarkedAsPurchased,
  reservation,
}) => {
  const { registry } = useGetRegistry(reservation.registryId.toString())
  const unmarkPurchasedModal = useTrackedUnmarkModal({ reservation })
  const handleUnmarkedAsPurchased = (res: Reservation | undefined) => {
    if (res) {
      showUnmarkedAsPurchasedToast(registry)
      onUnmarkedAsPurchased?.(res)
    }
  }
  const {
    mutate: unmarkPurchase,
    ctaText,
    isLoading: isUnmarking,
    isUnmarkEligible,
  } = useUnmarkAsPurchased({
    reservation,
    onSuccess: handleUnmarkedAsPurchased,
  })

  const onUnmarkAsPurchased = async () => {
    if (reservation.isSelfPurchase) {
      unmarkPurchase()
    } else {
      // launch warning modal
      const res: Reservation | undefined = await NiceModal.show(
        unmarkPurchasedModal,
        { reservation }
      )
      handleUnmarkedAsPurchased(res)
    }
  }

  return (
    <>
      {isUnmarkEligible && (
        <Button
          loading={isUnmarking}
          size="md"
          variant="destructive"
          onClick={onUnmarkAsPurchased}
        >
          {ctaText}
        </Button>
      )}
    </>
  )
}

export default GiftActions
